// extracted by mini-css-extract-plugin
export default {"imgwrap":"imageArea_imgwrap__YXY-J","i1":"imageArea_i1__7Xnbf","i2":"imageArea_i2__EcqHC","i3":"imageArea_i3__BHw8z"};